<template>
  <div class="seeResult">
    <div v-if="show == null" class="loads">
      <van-loading type="spinner" size="60" color="#1989fa" />
    </div>

    <div v-else>
      <div class="seeResult-main">
        <div class="seeResult-main-title">查询结果</div>

        <div class="seeResult-main-fail" v-if="show == 0">
          <img src="../../assets/TestKit/SeeFail.png" alt="" />
          <h2>查询失败</h2>
          <p>
            未查到您的检测记录<br />
            请联系客服人员。
          </p>
        </div>

        <div class="seeResult-main-not" v-if="show == 1">
          <!-- <template v-if="sort == 'fit'">
            <div class="seeResult-main-result-text">
              <ul class="" v-if="show == 2">
                <li>姓名: {{ details.name }}</li>
                <li style="margin: 0 0.625rem">
                  性别: {{ details.gender === 0 ? '女' : '男' }}
                </li>
                <li>年龄: {{ details.age + '岁' }}</li>
              </ul>
              <div class="idCardNo">身份证号: {{ details.idCardNo }}</div>
            </div>
            <p>
              您好，您的检测结果尚未出具结果出具时间未送检后5-10个工作日，请您耐心等待！
            </p>
            <img src="../../assets/TestKit/SeeIn.png" alt="" />
          </template> -->
          <img src="../../assets/TestKit/SeeIn.png" alt="" />
          <h2>检测中</h2>
          <!--        <p>您的检查结果还未生成<br/>-->
          <!--          请耐心等待！</p>-->
          <p>
            您好，您的检查结果尚未生成，肠癌筛查分析需要7个工作日的时间，请耐心等待，稍后再进行查询。
            如有其他问题，请联系工作人员为您解决。
          </p>
        </div>

        <div class="seeResult-main-result" v-if="show == 2">
          <div class="seeResult-main-result-text">
            <ul class="" v-if="show == 2">
              <li>姓名: {{ details.name }}</li>
              <li style="margin: 0 0.625rem">
                性别: {{ details.gender === 0 ? '女' : '男' }}
              </li>
              <li>年龄: {{ details.age + '岁' }}</li>
            </ul>
            <div class="idCardNo">身份证号: {{ details.idCardNo }}</div>
          </div>
          <div class="seeResult-main-result-select">
            <h2>肠道疾病风险评估结果</h2>
            <van-row gutter="10">
              <van-col span="8">
                <div
                  class="seeResult-main-result-select-box"
                  :class="
                    details.questionnaireResult === '低级' ||
                    details.questionnaireResult === '中级' ||
                    details.questionnaireResult === '高级'
                      ? details.questionnaireResult === '低级'
                        ? 'low lowAfter'
                        : 'low'
                      : null
                  "
                >
                  <div class="seeResult-main-result-select-box-line"></div>
                  <p>低风险</p>
                </div>
              </van-col>
              <van-col span="8">
                <div
                  class="seeResult-main-result-select-box"
                  :class="
                    details.questionnaireResult === '中级' ||
                    details.questionnaireResult === '高级'
                      ? details.questionnaireResult === '中级'
                        ? 'in inAfter'
                        : 'in'
                      : null
                  "
                >
                  <div class="seeResult-main-result-select-box-line"></div>
                  <p>中风险</p>
                </div>
              </van-col>
              <van-col span="8">
                <div
                  class="seeResult-main-result-select-box"
                  :class="
                    details.questionnaireResult === '高级'
                      ? 'high highAfter'
                      : null
                  "
                >
                  <div class="seeResult-main-result-select-box-line"></div>
                  <p>高风险</p>
                </div>
              </van-col>
            </van-row>
          </div>
          <div class="seeResult-main-result-select">
            <h2>无创肠癌粪便基因检测结果</h2>
            <p
              style="
                text-align: center;
                font-size: 26px;
                font-weight: bold;
                color: red;
              "
              v-if="details.detectResult === '不合格'"
            >
              样本不合格
            </p>
            <van-row gutter="10" v-else>
              <van-col span="12">
                <div
                  class="seeResult-main-result-select-box"
                  :class="
                    details.detectResult === '阴性' ? 'low lowAfter' : null
                  "
                >
                  <div class="seeResult-main-result-select-box-line"></div>
                  <p>阴性</p>
                </div>
              </van-col>
              <van-col span="12">
                <div
                  class="seeResult-main-result-select-box"
                  :class="
                    details.detectResult === '阳性' ? 'high highAfter' : null
                  "
                >
                  <div class="seeResult-main-result-select-box-line"></div>
                  <p>阳性</p>
                </div>
              </van-col>
            </van-row>
          </div>
          <template>
            <div
              class="seeResult-main-result-proposal"
              v-if="details.advice === 0"
            >
              根据以上检查结果，您患有大肠癌的风险较低，希望您继续保持健康的生活习惯。如您年龄≥40岁，建议每3-5年做一次肠镜检查，可联系工作人员为您预约。
            </div>
            <div
              class="seeResult-main-result-proposal"
              v-else-if="details.advice === 1"
            >
              根据以上检查结果，您应当进一步排查大肠癌风险。您可以继续参加本次大肠癌筛查活动，预约免费肠镜检查（结肠镜检查加泻药费用价值500元），检查医院为南开医院，具体预约时间请长按二维码与工作人员联系。
              注：无痛肠镜和术前检查需额外支付费用，医保和商保可正常使用。
            </div>
            <div class="seeResult-main-result-proposal" v-else>
              您可点击预约肠镜进行消化道检查；如有疑问也可点击人工询问。祝您身体健康！
            </div>
          </template>
          <template v-if="details.reportUrl && sort != 'fit'">
            <div @click="reportUrlClick(details.reportUrl)" class="reportUrl">
              查看基因检测报告结果
            </div>
          </template>
        </div>
      </div>

      <div class="seeResult-button">
        <van-button v-if="show == 2" @click="link" type="info" block
          >预约肠镜</van-button
        >
        <van-button @click="link" type="info" block>人工询问</van-button>
      </div>

      <div class="seeResult-text">
        {{
          sort == 'shi'
            ? '石氏医院免费提供肠镜检查项目'
            : '南开医院免费提供肠镜检查项目'
        }}
      </div>
      <!--    <img style="width: 100%;" :src="qrCode" alt="">-->
    </div>
  </div>
</template>

<script>
import qrCode from '../../assets/TestKit/qrCode.png'
import { Button, Row, Col, ImagePreview, loading } from 'vant'

export default {
  name: 'TestKitSeeResult',
  data() {
    return {
      show: null,
      isProposal: false,
      details: {},
      qrCode: qrCode,
      sort: null,
    }
  },
  created() {
    this.$isIos()
    this.getDetail(this.$route.query.state)
  },
  methods: {
    reportUrlClick(e) {
      ImagePreview([e])
    },
    getDetail(e) {
      this.sort = e
      this.$get('reagent/tokenResult', { sort: e }).then((res) => {
        if (res) {
          this.show = res.data.result

          if (this.show == 2) {
            this.resultDetail(res.data.reagentId)
          }
        }
      })
    },
    resultDetail(y) {
      this.$get('reagent/result', y, true).then((res) => {
        if (res) {
          this.details = res.data
        }
      })
    },
    link() {
      ImagePreview([qrCode])
    },
  },
  components: {
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [ImagePreview.name]: ImagePreview,
    [loading.name]: loading,
  },
}
</script>

<style lang="scss" scoped>
@import '../../style/TestKit/TestKitSeeResult';
.loads {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
